var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import PropTypes from "prop-types";
import { WhiteCard } from "../white-card";
import { TitleText } from "@socgress/ui/title-text";
import { IconList, ListShape } from "@socgress/ui/icon-list";
import { Container, Header, Body } from "./styled";
import styled from 'styled-components';
function ListJumbotron(_a) {
    var title = _a.title, animationData = _a.animationData, icon = _a.icon, list = _a.list, bodyMaxWidth = _a.bodyMaxWidth, children = _a.children, _b = _a.lottieHideOverflow, lottieHideOverflow = _b === void 0 ? false : _b, _c = _a.lottieStyle, lottieStyle = _c === void 0 ? {} : _c, _d = _a.containerStyle, containerStyle = _d === void 0 ? {} : _d;
    return (React.createElement(WhiteCard, { style: __assign({ overflow: "auto", overflowY: 'hidden' }, containerStyle) },
        React.createElement(Container, null,
            React.createElement(Header, null,
                React.createElement(TitleText, null, title)),
            React.createElement(Body, { lottieHideOverflow: lottieHideOverflow, bodyMaxWidth: bodyMaxWidth },
                React.createElement("div", null,
                    React.createElement(IconList, { list: list }),
                    children),
                React.createElement(LottieContainer, { style: lottieStyle }, icon ? React.createElement("img", { src: icon }) : null)))));
}
ListJumbotron.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    list: ListShape,
    children: PropTypes.node,
    bodyMaxWidth: PropTypes.number,
};
ListJumbotron.defaultProps = {
    image: null,
    list: [],
    children: null,
    bodyMaxWidth: 50,
};
export { ListJumbotron };
var LottieContainer = styled.div.withConfig({ displayName: "LottieContainer", componentId: "sc-1071901" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 200px;\n  height: 200px;\n  position: absolute;\n  overflow: hidden;\n  margin: 0;\n  outline: none;\n  right: 64px;\n  \n  img {\n    width: 200px;\n    height: 200px;\n  }\n  \n  @media(max-width: 768px) {\n    position: unset;\n    right: 0;\n  }\n"], ["\n  width: 200px;\n  height: 200px;\n  position: absolute;\n  overflow: hidden;\n  margin: 0;\n  outline: none;\n  right: 64px;\n  \n  img {\n    width: 200px;\n    height: 200px;\n  }\n  \n  @media(max-width: 768px) {\n    position: unset;\n    right: 0;\n  }\n"])));
var templateObject_1;
